import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INBOX_NEW_CONVERSATION';

export const {
    action: fetchReceivers,
    success: fetchReceiversSuccess,
    failed: fetchReceiversFailed,
} = createAction(
    `${domain}/FETCH_RECEIVERS`,
    inboxType => ({inboxType}),
    response => ({response}),
);

export const {action: showDetail} = createAction(`${domain}/SHOW_DETAIL`, nodeIndex => ({nodeIndex}));

export const {action: hideDetail} = createAction(`${domain}/HIDE_DETAIL`);

export const {action: toggleSelectReceiver} = createAction(`${domain}/TOGGLE_SELECT_RECEIVER`, receiver => ({
    receiver,
}));

export const {action: clearReceivers} = createAction(`${domain}/CLEAR_RECEIVERS`);

export const {action: removeReceiver} = createAction(`${domain}/REMOVE_RECEIVER`, receiverId => ({receiverId}));

export const {action: insertReceivers} = createAction(`${domain}/INSERT_RECEIVERS`, selectedReceivers => ({
    selectedReceivers,
}));
